import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierPaginationList, DossierStatus } from "../../types/Dossier";
import { PaginationFilters } from "../../types/Pagination";

export type DossierPaginationFilters = PaginationFilters & {
  dossierStatuses?: DossierStatus[] | null;
  employeeSearch?: string | null;
  accountIds?: string[];
};

export const getMyEmployerDossiers = (
  filters: DossierPaginationFilters,
  options: APQueryOptions = {}
) => {
  const {
    nextPageLink,
    pageSize,
    dossierStatuses,
    accountIds,
    employeeSearch,
    ...otherFilters
  } = filters;
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerDossiers", filters],
    queryFn: (): Promise<DossierPaginationList> => {
      return fetchWithAuth<DossierPaginationList>(
        "getMyEmployerDossiers",
        undefined,
        {
          queryParams: {
            ...otherFilters,
            nextPage: nextPageLink ?? undefined,
            pageSize: pageSize ? `${pageSize}` : undefined,
            dossierStatuses: dossierStatuses
              ? dossierStatuses.join(",")
              : undefined,
            accountIds: accountIds ? accountIds.join(",") : undefined,
            employeeSearch: employeeSearch ?? undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
    keepPreviousData: options.keepPreviousData,
  });
};
